var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8571 2H1.14287C0.511731 2 0 2.5117 0 3.14284V14.8572C0 15.4883 0.511731 16 1.14287 16H16.8571C17.4883 16 18 15.4883 18 14.8571V3.14284C18 2.5117 17.4883 2 16.8571 2ZM16.8571 3.14284V11.4545L14.6048 9.40683C14.2663 9.09912 13.7457 9.1114 13.4223 9.43513L11.1428 11.7142L6.64829 6.34569C6.30855 5.93997 5.68626 5.93598 5.34143 6.33683L1.14287 11.2163V3.14284H16.8571ZM12 6.14284C12 5.27484 12.7034 4.5714 13.5714 4.5714C14.4394 4.5714 15.1428 5.27484 15.1428 6.14284C15.1428 7.01085 14.4395 7.71425 13.5714 7.71425C12.7034 7.71428 12 7.01085 12 6.14284Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.5d9a87747d0c55ddc9f328aa1117b756.svg";
export { ForwardRef as ReactComponent };